import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const Classroom = () => {
     useEffect(() => {
        document.title = 'Classroom  Rules -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  Academics</li> 
     <li>Classroom  Rules</li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Classroom Guidelines for Effective Learning  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <p><b>1.</b> Respectful Communication: All students must communicate respectfully with teachers, staff, and fellow students. Disrespectful language or behavior will not be tolerated. </p>
       <p><b>2.</b> Punctuality: Students are expected to arrive on time for class. Late arrivals disrupt the learning environment and are disrespectful to both the teacher and other students. </p>
       <p><b>3.</b> Preparedness: Students should come to class prepared with all necessary materials, including textbooks, notebooks, and writing utensils. </p>
       <p><b>4.</b> Participation: Active participation in class discussions and activities is encouraged. Students should raise their hands to speak and listen attentively when others are speaking. </p>
       <p><b>5.</b> Electronic Devices Prohibited: Please note that the use of electronic devices, including cell phones, tablets, and laptops, is not permitted in the classroom.. </p>
       <p><b>6.</b> Cleanliness: Students are responsible for keeping their personal space clean and tidy. At the end of each class, students should ensure their area is clean and all trash is disposed of properly. </p>
       <p><b>7.</b> Homework: Homework assignments should be completed on time. Late submissions may result in a lower grade. </p>
       <p><b>8.</b> Academic Integrity: Cheating, plagiarism, and other forms of academic dishonesty will not be tolerated. Students are expected to do their own work and to cite sources appropriately. </p>
       <p><b>9.</b> Dress Code: Students should adhere to the school's dress code at all times. Clothing should be appropriate and not disruptive to the learning environment. </p>
       <p><b>10.</b> Food and Drink: Unless otherwise specified by the teacher, food and drink are not allowed in the classroom. </p>
       <p><b>11.</b> Respect for Property: Students should respect all school property, including desks, chairs, textbooks, and other materials. Any damage to school property may result in disciplinary action. </p>
       <p><b>12.</b> Absences: In case of an absence, it is the student's responsibility to catch up on missed work. Students should communicate with the teacher or classmates to obtain notes or assignments. </p>
       <p><b>13.</b> Safety: Students should follow all safety guidelines, especially during science labs or physical education classes. Any unsafe behaviour may result in disciplinary action. </p>
       <p><b>14.</b> Positive Attitude: Students are encouraged to maintain a positive attitude towards learning. This includes being open to new ideas, accepting constructive criticism, and showing enthusiasm for the subject matter. </p>
       <p><b>15.</b> Confidentiality: Students should respect the privacy of others. Personal information shared in the classroom should not be discussed outside of it.</p>
       
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default Classroom
